import {
  CREATE_DAEMON_SUCCESS,
  CREATE_DAEMON,
  CREATE_DAEMON_FAIL,
  REFRESH_DAEMON_ACCESS_TOKEN_SUCCESS,
  REFRESH_DAEMON_ACCESS_TOKEN_FAIL,
  REFRESH_DAEMON_ACCESS_TOKEN,
  GET_ALL_DAEMONS,
  GET_ALL_DAEMONS_SUCCESS,
  GET_ALL_DAEMONS_FAIL,
  GET_LAMBDAS,
  GET_LAMBDAS_SUCCESS,
  GET_LAMBDAS_FAIL,
  DEPLOY_LAMBDA,
  DEPLOY_LAMBDA_SUCCESS,
  DEPLOY_LAMBDA_FAIL,
  DEPLOYED_LAMBDA_DETAILS,
  DEPLOYED_LAMBDA_DETAILS_FAIL,
  DEPLOYED_LAMBDA_DETAILS_SUCCESS,
  ADD_RUNBOOK_SCRIPT,
  ADD_RUNBOOK_SCRIPT_SUCCESS,
  ADD_RUNBOOK_SCRIPT_FAIL,
  GET_RUNBOOK_SCRIPTS,
  GET_RUNBOOK_SCRIPTS_SUCCESS,
  GET_RUNBOOK_SCRIPTS_FAIL,
  DEPLOY_RUNBOOK_SCRIPT,
  DEPLOY_RUNBOOK_SCRIPT_SUCCESS,
  DEPLOY_RUNBOOK_SCRIPT_FAIL,
  EDIT_RUNBOOK_SCRIPT,
  EDIT_RUNBOOK_SCRIPT_SUCCESS,
  EDIT_RUNBOOK_SCRIPT_FAIL,
  GET_EXECUTE_RESULTS,
  GET_EXECUTE_RESULTS_SUCCESS,
  GET_EXECUTE_RESULTS_FAIL,
  GET_ALERTS_BASED_ON_RESOURCE,
  GET_ALERTS_BASED_ON_RESOURCE_SUCCESS,
  GET_ALERTS_BASED_ON_RESOURCE_FAIL,
  MAP_ALERT_TO_LAMBDA,
  MAP_ALERT_TO_LAMBDA_SUCCESS,
  MAP_ALERT_TO_LAMBDA_FAIL,
  DISASSOCIATE_ALERT_FROM_LAMBDA,
  DISASSOCIATE_ALERT_FROM_LAMBDA_SUCCESS,
  DISASSOCIATE_ALERT_FROM_LAMBDA_FAIL,
  GET_MAPPED_LAMBDA_ALERTS,
  GET_MAPPED_LAMBDA_ALERTS_FAIL,
  GET_MAPPED_LAMBDA_ALERTS_SUCCESS,
  GET_DAEMON_DETAIL,
  GET_DAEMON_DETAIL_SUCCESS,
  GET_DAEMON_DETAIL_FAIL,
  GET_ACCOUNT_LAMBDAS,
  GET_ACCOUNT_LAMBDAS_SUCCESS,
  GET_ACCOUNT_LAMBDAS_FAIL,
  GET_AVAILABLE_ROLES,
  GET_AVAILABLE_ROLES_SUCCESS,
  GET_AVAILABLE_ROLES_FAIL,
  UPDATE_DAEMON_TOKEN,
  UPDATE_DAEMON_TOKEN_SUCCESS,
  UPDATE_DAEMON_TOKEN_FAIL,
  GET_ALL_TOKENS,
  GET_ALL_TOKENS_SUCCESS, GET_ALL_TOKENS_FAIL
} from './actionTypes'

export const createDaemon = (payload) => ({
  type: CREATE_DAEMON,
  payload:payload
})

export const createDaemonSuccess = (payload) => ({
  type: CREATE_DAEMON_SUCCESS,
  payload:payload
})

export const createDaemonFail = (payload) => ({
  type: CREATE_DAEMON_FAIL,
  payload:payload
})

export const refreshDaemonAccessToken = (payload) => ({
  type: REFRESH_DAEMON_ACCESS_TOKEN,
  payload:payload
})

export const refreshDaemonAccessTokenSuccess = (payload) => ({
  type: REFRESH_DAEMON_ACCESS_TOKEN_SUCCESS,
  payload:payload
})

export const refreshDaemonAccessTokenFail = (payload) => ({
  type: REFRESH_DAEMON_ACCESS_TOKEN_FAIL,
  payload:payload
})

export const getAllDaemons = (payload) => ({
  type: GET_ALL_DAEMONS,
  payload:payload
})

export const getAllDaemonsSuccess = (payload) => ({
  type: GET_ALL_DAEMONS_SUCCESS,
  payload:payload
})

export const getAllDaemonsFail = (payload) => ({
  type: GET_ALL_DAEMONS_FAIL,
  payload:payload
})

export const getExecuteResults = (payload) => ({
  type: GET_EXECUTE_RESULTS,
  payload:payload
})

export const getExecuteResultsSuccess = (payload) => ({
  type: GET_EXECUTE_RESULTS_SUCCESS,
  payload:payload
})

export const getExecuteResultsFail = (payload) => ({
  type: GET_EXECUTE_RESULTS_FAIL,
  payload:payload
})

export const getLambdas = () => ({
  type: GET_LAMBDAS,
})

export const getLambdasSuccess = (payload) => ({
  type: GET_LAMBDAS_SUCCESS,
  payload: payload
})

export const getLambdasFail = (payload) => ({
  type: GET_LAMBDAS_FAIL,
  payload: payload
})

export const getAccountLambdas = (monitoring_system_id) => ({
  type: GET_ACCOUNT_LAMBDAS,
  payload:monitoring_system_id
})

export const getAccountLambdasSuccess = (payload) => ({
  type: GET_ACCOUNT_LAMBDAS_SUCCESS,
  payload: payload
})

export const getAccountLambdasFail = (payload) => ({
  type: GET_ACCOUNT_LAMBDAS_FAIL,
  payload: payload
})


export const deployLambda = (payload) => ({
  type: DEPLOY_LAMBDA,
  payload: payload
})

export const deployLambdaSuccess = (payload) => ({
  type: DEPLOY_LAMBDA_SUCCESS,
  payload: payload
})

export const deployLambdaFail = (payload) => ({
  type: DEPLOY_LAMBDA_FAIL,
  payload: payload
})

export const deployedLambdaDetails = (payload) => ({
  type: DEPLOYED_LAMBDA_DETAILS,
  payload: payload
})

export const deployedLambdaDetailsSuccess = (payload) => ({
  type: DEPLOYED_LAMBDA_DETAILS_SUCCESS,
  payload: payload
})

export const deployedLambdaDetailsFail = (payload) => ({
  type: DEPLOYED_LAMBDA_DETAILS_FAIL,
  payload: payload
})

export const addRunbookScript = (payload) => ({
  type: ADD_RUNBOOK_SCRIPT,
  payload:payload
})

export const addRunbookScriptSuccess = (payload) => ({
  type: ADD_RUNBOOK_SCRIPT_SUCCESS,
  payload:payload
})

export const addRunbookScriptFail = (payload) => ({
  type: ADD_RUNBOOK_SCRIPT_FAIL,
  payload:payload
})

export const getRunbookScripts = () => ({
  type: GET_RUNBOOK_SCRIPTS
})

export const getRunbookScriptSuccess = (payload) => ({
  type: GET_RUNBOOK_SCRIPTS_SUCCESS,
  payload:payload
})

export const getRunbookScriptFail = (payload) => ({
  type: GET_RUNBOOK_SCRIPTS_FAIL,
  payload:payload
})

export const deployRunbookScript = (payload) => ({
  type: DEPLOY_RUNBOOK_SCRIPT,
  payload:payload
})

export const deployRunbookScriptSuccess = (payload) => ({
  type: DEPLOY_RUNBOOK_SCRIPT_SUCCESS,
  payload:payload
})

export const deployRunbookScriptFail = (payload) => ({
  type: DEPLOY_RUNBOOK_SCRIPT_FAIL,
  payload:payload
})

export const editRunbookScript = (script) => {
  return {
    type: EDIT_RUNBOOK_SCRIPT,
    payload: script
  };
};

export const editRunbookScriptSuccess = (response) => {
  return {
    type: EDIT_RUNBOOK_SCRIPT_SUCCESS,
    payload: response
  };
};

export const editRunbookScriptFail = (error) => {
  return {
    type: EDIT_RUNBOOK_SCRIPT_FAIL,
    payload: error
  };
};


export const getAlertsBasedOnResource = (payload) => ({
  type: GET_ALERTS_BASED_ON_RESOURCE,
  payload: payload
})

export const getAlertsBasedOnResourceSuccess = (response) => ({
  type: GET_ALERTS_BASED_ON_RESOURCE_SUCCESS,
  payload: response
})

export const getAlertsBasedOnResourceFail = (error) => ({
  type: GET_ALERTS_BASED_ON_RESOURCE_FAIL,
  payload: error
})

export const mapAlertToLambda = (payload) => ({
  type: MAP_ALERT_TO_LAMBDA,
  payload: payload
})

export const mapAlertToLambdaSuccess = (response) => ({
  type: MAP_ALERT_TO_LAMBDA_SUCCESS,
  payload: response
})

export const mapAlertToLambdaFail = (error) => ({
  type: MAP_ALERT_TO_LAMBDA_FAIL,
  payload: error
})

export const disassociateAlertFromLambda = (payload) => ({
  type: DISASSOCIATE_ALERT_FROM_LAMBDA,
  payload: payload
})

export const disassociateAlertFromLambdaSuccess = (response) => ({
  type: DISASSOCIATE_ALERT_FROM_LAMBDA_SUCCESS,
  payload: response
})

export const disassociateAlertFromLambdaFail = (error) => ({
  type: DISASSOCIATE_ALERT_FROM_LAMBDA_FAIL,
  payload: error
})

export const getMappedLambdaAlert = (payload) => ({
  type: GET_MAPPED_LAMBDA_ALERTS,
  payload: payload
})

export const getMappedLambdaAlertsSuccess = payload => ({
  type: GET_MAPPED_LAMBDA_ALERTS_SUCCESS,
  payload: payload
})

export const getMappedLambdaAlertFail = error => ({
  type: GET_MAPPED_LAMBDA_ALERTS_FAIL,
  payload: error
})

export const getDaemonDetail = (payload) => ({
  type: GET_DAEMON_DETAIL,
  payload: payload
})

export const getDaemonDetailSuccess = (payload) => ({
  type: GET_DAEMON_DETAIL_SUCCESS,
  payload: payload
})

export const getDaemonDetailFail = (error) => ({
  type: GET_DAEMON_DETAIL_FAIL,
  payload: error
})

export const getAvailableRoles = () => ({
  type: GET_AVAILABLE_ROLES,
})

export const getAvailableRolesSuccess = (payload) => ({
  type: GET_AVAILABLE_ROLES_SUCCESS,
  payload: payload
})

export const getAvailableRolesFail = (error) => ({
  type: GET_AVAILABLE_ROLES_FAIL,
  payload: error
})


export const getAllTokens = () => ({
  type: GET_ALL_TOKENS,
})
export const getAllTokensSuccess = (payload) => ({
  type: GET_ALL_TOKENS_SUCCESS,
  payload: payload
})

export const getAllTokensFail = (error) => ({
  type: GET_ALL_TOKENS_FAIL,
  payload: error
})

export const updateDaemonTokenDetails = (payload) => ({
  type: UPDATE_DAEMON_TOKEN,
  payload: payload
})

export const updateDaemonTokenDetailsSuccess = (payload) => ({
  type: UPDATE_DAEMON_TOKEN_SUCCESS,
  payload: payload
})

export const updateDaemonTokenDetailsFail = (error) => ({
  type: UPDATE_DAEMON_TOKEN_FAIL,
  payload: error
})

